export default "__VITE_ASSET__969fc8f3__"